
import React from "react";
import { Badge } from "@/components/ui/badge";
import { Tag as TagIcon } from "lucide-react";

type TagProps = {
  tags: string[];
  className?: string;
  onClick?: (tag: string) => void;
};

export const CustomerTags = ({ tags, className = "", onClick }: TagProps) => {
  if (!tags?.length) return null;
  
  return (
    <div className={`flex flex-wrap gap-1 ${className}`}>
      {tags.map((tag) => (
        <Badge 
          key={tag} 
          variant="outline" 
          className={`text-xs py-0 ${onClick ? 'cursor-pointer hover:bg-secondary' : ''}`}
          onClick={onClick ? () => onClick(tag) : undefined}
        >
          <TagIcon className="w-3 h-3 mr-1" />
          {tag}
        </Badge>
      ))}
    </div>
  );
};
